import './SearchGamesList.css';
import React from 'react';
import { useSelector } from 'react-redux';
import { FixedSizeList as List } from 'react-window';
import { useTranslations } from '../../../../hooks/use-translations.hook';
import { SearchGamesListItem } from '../SearchGamesListItem';

export const SearchGamesList = ({
    resultGameIds,
    searchQuery,
    searchWindowDimensions = {},
}) => {
    const { t } = useTranslations();
    const { gamesById } = useSelector((state) => (state.casino));

    if (!gamesById) {
        return null;
    }

    const gamesFoundAmount = resultGameIds.length;
    const gamesToRender = resultGameIds.map((gameId) => gamesById[gameId]);

    return (
        <div className="asg-search-results-games-list">
            <div className="asg-search-results-games-list__title">
                {gamesFoundAmount} {t('resultsFor')}
                <span className="asg-search-results-games-list__query">{searchQuery}</span>
            </div>

            <div className="asg-search-results-games-list__list">
                <List
                    className="asg-search-results-games-list__window"
                    itemSize={searchWindowDimensions.itemSize ?? 80}
                    height={searchWindowDimensions.height ?? 573}
                    width={searchWindowDimensions.width ?? 360}
                    itemCount={gamesFoundAmount}
                    itemData={gamesToRender}
                    direction="rtl"
                >
                    {SearchGamesListItem}
                </List>
            </div>
        </div>
    );
};
